import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { OutboundDashboardComponent } from './components/outbound-dashboard/outbound-dashboard.component';
import { LaunchBrandPipelineModalComponent } from './components/outbound-dashboard/launch-brand-pipeline.modal';
import { SequenceBuilderComponent } from './components/sequence-builder/sequence-builder.component';
import { ConduitComponent } from './components/conduit/conduit.component';
import { LaunchBrandPipelineClient } from './services/launch-brand-pipeline.client';

@NgModule({
    declarations: [
        OutboundDashboardComponent,
        LaunchBrandPipelineModalComponent,
        SequenceBuilderComponent,
        ConduitComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
    ],
    providers: [
        LaunchBrandPipelineClient,
    ],
    exports: [
        OutboundDashboardComponent,
        LaunchBrandPipelineModalComponent,
        SequenceBuilderComponent,
        ConduitComponent,
    ]
})
export class OutboundUIModule { }
